import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { queryKeys } from './queryKeys';
import type { StatusHistoryEntry } from '@/types';

export function useWorkOrderHistory(bookingId: string | undefined) {
  return useQuery({
    queryKey: queryKeys.workOrders.history(bookingId ?? ''),
    queryFn: () => api.get<StatusHistoryEntry[]>(`/work-orders/${bookingId ?? ''}/history`),
    enabled: !!bookingId,
  });
}
